'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Record } from 'immutable';
import { fromNetwork } from './BudgetRecord';
import { fromMillis } from './ScheduleRecord';
export default class CampaignInfoRecord extends new Record({
  id: null,
  name: null,
  status: null,
  isDefault: false,
  network: null,
  type: null,
  budget: null,
  schedule: null
}) {
  constructor(_ref) {
    let {
      campaignBudget,
      startTimeMillis,
      endTimeMillis
    } = _ref,
        info = _objectWithoutPropertiesLoose(_ref, ["campaignBudget", "startTimeMillis", "endTimeMillis"]);

    super(Object.assign({}, info, {
      budget: campaignBudget && fromNetwork(campaignBudget),
      schedule: fromMillis(startTimeMillis, endTimeMillis)
    }));
  }

}